// import InvoiceListOptions from '@/components/Invoice/InvoiceListOptions.vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { PaymentsEmbed } from '../tables/Payments'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const paymentsColumns: ColumnDef<PaymentsEmbed.ListItem>[] = [
  {
    accessorKey: 'connectedAccountSeller.name',
  },
  {
    accessorKey: 'connectedAccountSeller.businessName',
  },
  {
    accessorKey: 'customer.name',
  },
  {
    accessorKey: 'customer.email',
  },
  {
    accessorKey: 'description',
  },
  {
    accessorKey: 'grossAmount',
  },
  {
    accessorKey: 'paymentStatus',
    size: 120,
  },
  {
    accessorKey: 'insertTime',
    size: 150,
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 75,
  },
]
